import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import BaseButton from 'features/app/components/BaseButton';
import { Paper } from 'features/app/components/Paper';
import { tutorialsPaths } from 'features/tutorials/routes/paths';
import { useMessage } from 'features/message/hooks/useMessage';
import { getBulkOrderTemplate } from 'features/dashboard/api';
import { useTranslation } from 'hooks/useTranslation';
import { FileUtils } from 'utils/FileUtils';
import { ErrorUtils } from 'utils';

import { ReactComponent as ExternalLinkIcon } from 'assets/icons/external-link-icon.svg';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

export const BulkUploadTopSection = () => {
  const { t } = useTranslation('dashboard');
  const direction = i18n.dir()

  const classes = useStyles({ direction });
  const { showSuccessMessage, showErrorMessage } = useMessage();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClick = async () => {
    setIsDownloading(true);
    try {
      const { data } = await getBulkOrderTemplate();

      FileUtils.downloadFile(data);
      showSuccessMessage(t('sampleFileHasBeenDownloadedSuccessfully'));
    } catch (error) {
      showErrorMessage(ErrorUtils.convertError(error));
    }

    setIsDownloading(false);
  };

  return (
    <Paper borderRadius={20} className={classes.container}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Link to={tutorialsPaths.static.root} className={classes.link}>
          <Typography display="inline" className={classes.linkText}>
            {t('bulkUploadInstructionLink')}
          </Typography>
          <ExternalLinkIcon />
        </Link>
        <BaseButton maxWidth={269} disabled={isDownloading} onClick={handleDownloadClick}>
          {t('downloadSampleFile')}
        </BaseButton>
      </Box>
    </Paper>
  );
};
